import { get } from 'lodash';
export function uniqueID(length = 9) {
    return Math.random()
        .toString(36)
        .substr(2, length);
}
export function UniqueIdPlugin(Vue, options) {
    const length = get(options, 'length', 6);
    Vue.mixin({
        beforeCreate() {
            this.$uid = uniqueID(length);
        }
    });
}
//# sourceMappingURL=unique-id.js.map